import { LoadingButton } from "@mui/lab";
import { Card, Typography, Grid, TextField, Divider } from "@mui/material";
import { Box, Stack, styled } from "@mui/system";
import { Button } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getAppName, getBrandLoginLogo } from "../utils/const";
// import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
// import dayjs, { Dayjs } from 'dayjs';

// import Typography from '../styles/overrides/Typography';
import { useFormik } from "formik";

const FlexBox = styled(Box)(() => ({ display: "flex", alignItems: "center" }));
const JustifyBox = styled(FlexBox)(() => ({ justifyContent: "center" }));
const ContentBox = styled(JustifyBox)(() => ({
  height: "100%",
  padding: "32px",
  background: "rgba(0, 0, 0, 0.01)",
}));

export default function LoginForm({ onSumbit }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const navigate = useNavigate();

  const loginLogoImage = getBrandLoginLogo(); // "she_logo.png";

  useEffect(() => {
    if (formData === null) {
      return;
    }
    // console.log(formData);
    if (onSumbit !== undefined) {
      onSumbit(formData);
    }
  }, [formData]);

  const formik = useFormik({
    initialValues: {
      user: "",
      password: "",
    },
    // validateOnMount: true,
    // validationSchema: LoginSchema,
  });

  const handleSubmit = () => {
    console.debug("handleOnSubmit");
    if (formik.values.user === "" && formik.values.password === "") {
      console.debug("Please fill in all fields");
      return;
    }

    setFormData(formik.values);
    // setLoading(true);
  };

  const handleRegister = () => {
    navigate("/register");
  };

  return (
    <Grid container alignItems="center" px={2}>

      <Grid
        item
        container
        direction="column"
        justifyContent={"center"}
        alignItems={"center"}
        gap={2}
        sm={12}
        xs={12}
        order={{ xs: 1, sm: 2 }}
      >

        {/* <Box
          component="img"
          width="120px"
          alt="SheLogo"
          src="/she_logo.png"
          alignSelf="center"
        /> */}

        <Stack>
          <Typography
            variant="h2"
            align="center"
            sx={{ fontWeight: "bold", pt: 1 }}
          >
            Integrated Digital Science and Sports Management Centre
            <br />
            Sport Event Dashboard
          </Typography>
        </Stack>
        <TextField
          fullWidth
          type="text"
          name="user"
          label="用戶名字"
          variant="outlined"
          // onBlur={handleBlur}
          value={formik.values.user}
          onChange={formik.handleChange}
        />

        <TextField
          fullWidth
          name="password"
          type="password"
          label="密碼"
          variant="outlined"
          // onBlur={handleBlur}
          value={formik.values.password}
          onChange={formik.handleChange}
        // onChange={handleChange}
        // helperText={touched.password && errors.password}
        // error={Boolean(errors.password && touched.password)}
        />


        <LoadingButton
          type="submit"
          color="primary"
          loading={loading}
          variant="contained"
          onClick={handleSubmit}
          sx={{ mt: 1 }}
          fullWidth
        >
          登入帳號
        </LoadingButton>
        <Box width="100%">
          <Divider sx={{ my: 1 }} />
        </Box>



        {/* </form> */}
      </Grid>
    </Grid>
  );
}
